import React, { Component } from 'react'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import enhanceWithClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'
import Select from '@components/Select'

class PrincipalTeams extends Component {
  static propTypes = {
    principalTeamsData: PropTypes.object,
    setActiveTeamId: PropTypes.func,
    activeTeamId: PropTypes.number,
    dashboardStore: PropTypes.object,
    performanceDate: PropTypes.string,
    teamRevenueDate: PropTypes.string,
    accountRevenueDate: PropTypes.string,
    honorariaAnalysisDate: PropTypes.string,
    accountRevenueQuarter: PropTypes.number,
    accountRevenueYear: PropTypes.number
  }

  handleTeamChange = event => {
    const activeTeamId = event.target.value
    this.props.setActiveTeamId(activeTeamId)

    const {
      getTeamRevenueWidgetData,
      getAccountRevenueWidgetData,
      getAccountRevenueQuarterlyWidgetData,
      getHonorariaAnalysisWidgetData,
      getPerformanceWidgetData
    } = this.props.dashboardStore

    getPerformanceWidgetData(
      moment(this.props.performanceDate).format('MM-YYYY'),
      activeTeamId
    )
    getTeamRevenueWidgetData(
      moment(this.props.teamRevenueDate).format('MM-YYYY'),
      activeTeamId
    )
    getAccountRevenueWidgetData(
      moment(this.props.accountRevenueDate).format('MM-YYYY'),
      activeTeamId
    )
    getAccountRevenueQuarterlyWidgetData({
      quarter: this.props.accountRevenueQuarter,
      year: this.props.accountRevenueYear,
      teamId: activeTeamId
    })
    getHonorariaAnalysisWidgetData(
      moment(this.props.honorariaAnalysisDate).format('MM-YYYY'),
      activeTeamId
    )
  }

  render () {
    if (!this.props.principalTeamsData) return null

    return (
      <div className='principalTeams-widget'>
        <Select
          value={this.props.activeTeamId ?? this.props.principalTeamsData[0].id}
          options={this.props.principalTeamsData.map(team => ({
            value: team.id,
            label: team.name
          }))}
          onChange={this.handleTeamChange}
          disabled={false}
        />
      </div>
    )
  }
}

export default inject(
  'userStore',
  'dashboardStore'
)(enhanceWithClickOutside(observer(PrincipalTeams)))
